import { createAsyncThunk } from '@reduxjs/toolkit';

// Any changes here for the payload will effect flow timezone as well.
// As the timezones here are used as a reference for flow timezones.
function getMeEdit(_, { extra: { http } }) {
  return http.get(`/me/edit`);
}

function patchMe({ user }, { extra: { http } }) {
  return http.patch(`/me`, { user });
}

export const editMe = createAsyncThunk('me/edit', getMeEdit);

export const updateMe = createAsyncThunk('me/update', patchMe);
